<template>
    <div class="business-page">
        <div class="block vw-business-block">
            <router-link
                v-for="(business, index) in businessList"
                :key="index"
                :to="{ name: 'businessDetail', params: { id: business.businessId } }"
                class="business-item"
            >
                <img class="main-image" :src="business.homepageLittleImage" alt="">
                <img class="icon-image" :src="business.listDefaultImage" alt="">
                <h6>{{isCn ? business.cnBusinessName : business.enBusinessName}}</h6>
                <p>{{isCn ? business.cnBriefIntro : business.enBriefIntro}}</p>
                <strong>{{lang.toDetail}} <q-icon name="arrow_forward" /></strong>
            </router-link>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/lang';
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';
import router from '@/router';

export default {
    name: 'businessDomestic',
    components: {
        Layout,
    },
    props: {
        pageId: [String, Number],
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            businessList: [],
        };
    },
    watch: {
        pageId() {
            this.renderNav();
        },
    },
    mounted() {
        this.renderNav();
    },
    methods: {
        goBack() {
            router.go(-1);
        },
        renderNav() {
            ajax.get('/web/business/business_list.json', {
                businessTypeId: this.$props.pageId,
                page: 1,
                pageSize: 1000,
            }).then((result) => {
                this.businessList = result.dataList;
            }).catch(() => {});
        },
    },
};
</script>
<style lang="less" scoped>
    .vw-business-block {
        padding-bottom: 15px;
    }
    .vw-business-block .business-item {
        display: block;
        position: relative;
        margin: 5px 15px;
        width: 345px;
        background: #fff;
        text-align: center;
        img.main-image {
            display: block;
            width: 345px;
            height: 259px;
        }
        img.icon-image {
            position: absolute;
            left: 50%;
            top: 239px;
            border-radius: 50%;
            transform: translate(-50%, 0);
            width: 40px;
            height: 40px;
            z-index: 2;
            box-shadow:0px 0px 3px 0px rgba(0,0,0,0.08);
        }
        h6 {
            text-align: center;
            margin-top: 25px;
            font-size: 14px;
            font-weight: 600;
        }
        p {
            padding: 5px 8px;
            line-height: 18px;
            font-size: 12px;
            word-break: break-word;
            color: #9B9B9B;
            text-align: left;
        }
        strong {
            display: block;
            color: #4A4A4A;
            font-size: 14px;
            font-weight: 600;
            padding: 12px 12px 8px;
            text-align: right;
        }
    }
</style>
